<template>
  <DatatableReportV3
    id="warranties-todo-table"
    title="Warranties To-Do"
    download-url="/reports/warranties_todo"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import EquipmentWarrantyLink from "@/Equipment/EquipmentWarrantyLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "purchase_date",
            title: "Purchase Date",
            filterName: "sold_on"
          },
          {
            data: "customer",
            footerClassName: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers,
            title: "Customer"
          },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name" },
          { data: "address", orderable: false },
          { data: "job" },
          { data: "invoice" },
          {
            data: "technician",
            filterName: "technician_id"
          },
          {
            data: "provider_name",
            title: "Provider",
            filterName: "provider",
            footerClassName: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.providers
          },
          {
            data: "program_name",
            title: "Warranty Program",
            filterName: "program",
            footerClassName: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.programs
          },
          { data: "sku_number", title: "SKU #" },
          {
            data: "labor_rate",
            title: "Labor Rate",
            className: "text-right",
            searchable: false
          },
          {
            data: "program_cost",
            title: "Program Cost",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.cost,
            searchable: false
          },
          {
            data: "term_years",
            title: "Term (years)",
            searchable: false
          },
          {
            data: "equipment",
            title: "Equipment (captured)",
            searchable: false,
            orderable: false
          },
          {
            data: "status",
            orderable: false,
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "equipment-warranty-link-vue",
            component: EquipmentWarrantyLink,
            options: {
              store
            }
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
